export const AB_SRP_LAYOUT_COOKIE_MAP   = 'ab-map-view';
export const AB_SRP_LAYOUT_COOKIE_LIST  = 'ab-list-view';
export const AB_SRP_LAYOUT_COOKIE_MIXED = 'ab-mixed-view';

export const RESIZE_MAP  = "BC.MAP.RESIZE";
export const VIEW_CHANGE = "BC.SET.VIEW.TYPE";



// WEBPACK FOOTER //
// ./srp/basecamp/constants.js